import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import { createDisplayNameForButtonCellElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellElement } from "../../utils/getTestId";

import classes from "./ButtonCellLeftAddon.styl";

const LEFT_ADDON_TEST_ID = createTestIdForButtonCellElement("left-addon");

interface IButtonCellLeftAddon {}

export const ButtonCellLeftAddon: FC<
    PropsWithChildren<IButtonCellLeftAddon>
> = ({ children }): JSX.Element => {
    return (
        <div className={classes["left-addon"]} data-tsid={LEFT_ADDON_TEST_ID}>
            {children}
        </div>
    );
};

ButtonCellLeftAddon.displayName =
    createDisplayNameForButtonCellElement("LeftAddon");

export default ButtonCellLeftAddon;
